import configs from '../../configs';
import actions from './actions';
import mutations from './mutations';
var product = configs.product,
  time = configs.time,
  theme = configs.theme,
  currencies = configs.currencies;
var globalTheme = theme.globalTheme,
  menuTheme = theme.menuTheme,
  toolbarTheme = theme.toolbarTheme,
  isToolbarDetached = theme.isToolbarDetached,
  isContentBoxed = theme.isContentBoxed,
  isRTL = theme.isRTL;
var currency = currencies.currency,
  availableCurrencies = currencies.availableCurrencies;

// state initial values
var state = {
  product: product,
  time: time,
  // currency
  currency: currency,
  availableCurrencies: availableCurrencies,
  // themes and layout configurations
  globalTheme: globalTheme,
  menuTheme: menuTheme,
  toolbarTheme: toolbarTheme,
  isToolbarDetached: isToolbarDetached,
  isContentBoxed: isContentBoxed,
  isRTL: isRTL,
  // App.vue main toast
  toast: {
    show: false,
    color: 'black',
    message: '',
    timeout: 3000
  },
  showLoading: false,
  showMessage: false,
  toastMessage: {},
  newAudience: {},
  menuSelected: 'menu.data_platform'
};
export default {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations
};